import { render } from "./UserProfilePage.vue?vue&type=template&id=0b86656a&scoped=true"
import script from "./UserProfilePage.vue?vue&type=script&lang=js"
export * from "./UserProfilePage.vue?vue&type=script&lang=js"

import "./UserProfilePage.vue?vue&type=style&index=0&id=0b86656a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b86656a"]])

export default __exports__